export default __webpack_public_path__ + "static/media/logo_suma.b5692565.svg";